import ListUsers from './components/listUsers';
import userSignOutPage from "./components/userSignOutPage";

export default {
    icon: '',
    url: 'usuarios',
    name: 'Usuários',
    routes: [
        {
            path: '/usuarios',
            name: 'users',
            component: ListUsers
        },
        {
            path: '/usuarios/sair',
            name: 'user.logout',
            component: userSignOutPage
        },
    ]
}